var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNevaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 32,
    viewBox: "0 0 103 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13889 32H0V0H5.53571L23.7882 22.5736V0H29.9271V32H23.0496L6.13889 11.1532V32ZM33.5721 32V21.3976H39.9028V26.0241H58.5082L61.0123 32H33.5721ZM33.5721 18.6988V12.7229H53.7915L55.6696 18.6988H33.5721ZM39.9028 10.4096H33.5721V0H60.0882L68.1263 22.4756L76.514 0H83.2262L70.612 32H65.3957L55.6118 6.55422H39.9028V10.4096ZM102.4 32H72.3564L84.9706 0H89.9927L102.4 32ZM93.0848 25.8313L87.2874 10.8941L81.49 25.8313H93.0848Z",
    fill: "#45FFA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNevaLogo);
export default __webpack_public_path__ + "static/media/neva_logo.fc01618f094a35c56e2a5a1ca3d427de.svg";
export { ForwardRef as ReactComponent };